import { colors } from 'fitify-ui'
import { typographyStyles } from 'fitify-ui/src/typography/generated/Typography'
import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledPagination = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;

  ${phone(css`
    gap: 6px;
  `)};
`

export const StyledEllipsis = styled.span`
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  color: ${colors.Gray400};

  ${typographyStyles('Text/Body 14')}

  ${phone(css`
    width: 36px;
    height: 36px;
  `)};
`
